<template>
  <v-form v-model="valid" ref="mainForm">
    <data-iterator
      :list="sas.sasMembreAutreOrdre"
      add-new-text="Ajouter un ordre professionnel"
      :live="{ endpoint: 'sas-membre-autre-ordre', sasId: sas.id }"
      :icon="$getIcon('job')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <p class="mb-0">{{ item.nom }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="ordre_nom" v-model="item.nom" :live="liveSasMembreAutreOrdre(6804, item)" />
        <TextFieldLive code="ordre_numero" v-model="item.nPermis" :live="liveSasMembreAutreOrdre(6805, item)" />
        <DatePickerLive
          code="ordre_debut"
          v-model="item.dateDeDebut"
          :live="liveSasMembreAutreOrdre(6807, item)"
          :maxValue="convertDateToString(new Date())"
        />
        <DatePickerLive
          code="ordre_fin"
          v-model="item.dateDeFin"
          :live="liveSasMembreAutreOrdre(6808, item)"
          :maxValue="convertDateToString(new Date())"
        />
        <FileInput code="ordre_preuve" :file="item.preuve" :live="liveSasMembreAutreOrdre(6806, item)" />
        <FileInput code="ordre_lettre" :file="item.attestationDeMembre" :live="liveSasMembreAutreOrdre(6809, item)" />
      </template>
    </data-iterator>
  </v-form>
</template>
<script>
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"

export default {
  mixins: [StepFormWithValidation, DatesHelpers],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasMembreAutreOrdre(cle, item) {
      return { endpoint: "sas-membre-autre-ordre", cle: cle, fileId: item.id }
    }
  }
}
</script>

<style></style>
